import React, { useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Formik } from "formik";
import { EditBookVS } from "../../../util/validation";
import Input from "../../common/input";
import TextArea from "../../common/textArea";
import CoverPhotoBaseURL from "../../../util/coverPhotoBaseURL";

import "./style.css";
import { ImageUpload } from "../../../util/mediaUpload";
import { toastMessage } from "../../common/toast";
import { EditBook } from "../../../services/libraryService";

function EditBookDetails({ openModal, HideModal, item, getPublisherBooks }) {
  const [coverPhotoURL, setCoverPhotoURL] = useState(null);
  const [coverPhoto, setCoverPhoto] = useState(null);
  const initialValues = {
    name: item?.bookname,
    writer: item?.writername,
    price: item?.price,
    description: item?.description,
  };
  const CloseModal = () => {
    HideModal();
  };
  const handleFiles = (e) => {
    let file = e.target.files[0];
    ImageUpload(e, (res) => {
      if (res) {
        const fileImage = URL.createObjectURL(file);
        setCoverPhotoURL(fileImage);
        setCoverPhoto(res);
      }
    });
  };
  const user = useSelector((state) => state.root.user);
  const handleEdit = async (values, action) => {
    let formData = new FormData();
    if (coverPhoto != null) {
      formData.append("coverimage", coverPhoto);
    }
    formData.append("bookname", values.name);
    formData.append("writername", values.writer);
    formData.append("price", values.price);
    formData.append("description", values.description);
    formData.append("_id", item._id);
    await EditBook(user.token, formData)
      .then((res) => {
        if (res.statusText === "OK") {
          action.setSubmitting(false);
          toastMessage("Book Updated Successfully", "success");
          HideModal();
          getPublisherBooks();
        } else {
          action.setSubmitting(false);
          toastMessage(res.data, "error");
        }
      })
      .catch((err) => {
        action.setSubmitting(false);
        toastMessage(
          err?.response?.data?.message
            ? err.response.data.message
            : "Check your Network Connection",
          "error"
        );
      });
  };
  return (
    <Modal
      size="lg"
      backdrop="static"
      show={openModal}
      onHide={HideModal}
      centered
    >
      <button
        type="button"
        className="close custom-modal-close"
        onClick={CloseModal}
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <Formik
        initialValues={initialValues}
        onSubmit={(values, action) => {
          console.log("Here");
          action.setSubmitting(true);
          handleEdit(values, action);
        }}
        validationSchema={EditBookVS}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleSubmit,
          isSubmitting,
        }) => (
          <div className="p-5">
            <div className="modal-body modal-body-flex">
              <label className="img-bg" role="button">
                <img
                  src={
                    coverPhotoURL
                      ? coverPhotoURL
                      : item?.coverimage &&
                        `${CoverPhotoBaseURL}${item?.coverimage}`
                  }
                  className="signup-image"
                />
                <input type="file" onChange={handleFiles} />
                <img
                  src={require("../../../../assets/icons/pencil.svg").default}
                  className="img-edit"
                />
              </label>
              <div className="edit-book-details-container">
                <div className="edit-book-details-subContainer">
                  <h5>Name*</h5>
                  <Input
                    type="text"
                    onChange={handleChange("name")}
                    value={values.name}
                  />
                  <div className="error3">
                    {touched.name && errors.name ? errors.name : ""}
                  </div>
                </div>
                <div className="edit-book-details-subContainer">
                  <h5>Writer*</h5>
                  <Input
                    type="text"
                    onChange={handleChange("writer")}
                    value={values.writer}
                  />
                  <div className="error3">
                    {touched.writer && errors.writer ? errors.writer : ""}
                  </div>
                </div>
                <div className="edit-book-details-subContainer">
                  <h5>Price in USD*</h5>
                  <Input
                    type="number"
                    onChange={handleChange("price")}
                    value={values.price}
                    disabled
                  />
                  <div className="error3">
                    {touched.price && errors.price ? errors.price : ""}
                  </div>
                </div>
                <div className="edit-book-details-subContainer">
                  <h5>Description*</h5>
                  <TextArea
                    type="text"
                    row={3}
                    onChange={handleChange("description")}
                    value={values.description}
                  />
                  <div className="error4">
                    {touched.description && errors.description
                      ? errors.description
                      : ""}
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-center">
              <Button className="custom-edit-btn mt-3" onClick={handleSubmit}>
                {isSubmitting ? (
                  <Spinner animation="grow" size="sm" />
                ) : (
                  <p className="mb-0">Save</p>
                )}
              </Button>
            </div>
          </div>
        )}
      </Formik>
    </Modal>
  );
}

export default EditBookDetails;
